import { render, staticRenderFns } from "./AreaEmbargadaGOIAS.vue?vue&type=template&id=5b539404&lang=pug"
import script from "./AreaEmbargadaGOIAS.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaGOIAS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports